// adhocLaneSlice.js

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
   addAdhocLaneApiCall,
   editAdhocLaneApiCall,
   getAdhocLaneApiCall,
   getAdhocLaneListApiCall,
   updateAdhocLaneReviewStautsApiCall,
} from "../../Api/api";

// Define an initial state for the slice
const initialState = {
   lane: null,
   loading: false,
   error: null,
   laneList: [],
   singleLane: null,
};

export const addAdhocLaneAsync = createAsyncThunk(
   "adhoc-lane/add-lane",
   async ({ data, err, done }) => {
      try {
         const response = await addAdhocLaneApiCall(data);
         if (response.status === 200) {
            done && done();
            return response.data;
         } else {
            err && err();
         }
      } catch (error) {
         // You can customize the error handling here
         err && err();
         throw error.response.data;
      }
   }
);

// Edit adhocLane
export const editAdhocLaneAsync = createAsyncThunk(
   "adhoc-lane/edit-lane",
   async ({ data, err, done }, thunkAPI) => {
      try {
         const { data: response } = await editAdhocLaneApiCall(data);
         if (response.statusCode === 200) {
            done && done();
            return thunkAPI.fulfillWithValue(response);
         } else {
            throw response;
         }
      } catch (error) {
         // You can customize the error handling here
         err && err(error.message);
         return thunkAPI.rejectWithValue(error);
      }
   }
);

export const fetchAdhocLaneListAsync = createAsyncThunk(
   "adhoc-lane/fetch-lane",
   async ({ done, err }, thunkAPI) => {
      try {
         const response = await getAdhocLaneListApiCall();
         if (response.data?.statusCode === 200) {
            done && done();
            return thunkAPI.fulfillWithValue(response.data);
         } else {
            throw response;
         }
      } catch (error) {
         err && err();
         thunkAPI.rejectWithValue(error?.response?.data);
         throw error?.response?.data;
      }
   }
);

export const fetchAdhocLaneAsync = createAsyncThunk(
   "adhoc-lane/fetch-single-lane",
   async ({ laneId, done, err }, thunkAPI) => {
      try {
         const response = await getAdhocLaneApiCall(laneId);
         if (response.data?.statusCode === 200) {
            done && done();
            return thunkAPI.fulfillWithValue(response.data);
         } else {
            throw response;
         }
      } catch (error) {
         err && err();
         thunkAPI.rejectWithValue(error?.response?.data);
         throw error?.response?.data;
      }
   }
);

export const updateAdhocLaneReviewStautsAsync = createAsyncThunk(
   "adhoc-lane/update-review-status",
   async ({ data, done, err }, thunkAPI) => {
      try {
         const { data: response } = await updateAdhocLaneReviewStautsApiCall(data);
         if (response.statusCode === 200) {
            done && done();
            return thunkAPI.fulfillWithValue(response);
         } else {
            throw response;
         }
      } catch (error) {
         err && err(error.message);
         return thunkAPI.rejectWithValue(error);
      }
   }
);

// Create a slice of the Redux store
const adhocLaneSlice = createSlice({
   name: "adhoc-lane",
   initialState,
   reducers: {
      // You can define additional synchronous actions here if needed
      resetLane: (state) => {
         state.singleLane = null;
      },
   },
   extraReducers: (builder) => {
      builder
         .addCase(addAdhocLaneAsync.pending, (state) => {
            state.loading = true;
            state.error = null;
         })
         .addCase(addAdhocLaneAsync.fulfilled, (state, action) => {
            state.loading = false;
            state.lane = action.payload;
         })
         .addCase(addAdhocLaneAsync.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
         })
         .addCase(fetchAdhocLaneListAsync.pending, (state) => {
            state.loading = true;
            state.error = null;
         })
         .addCase(fetchAdhocLaneListAsync.fulfilled, (state, action) => {
            state.loading = false;
            let payloadData = action.payload;
            if (payloadData?.res) payloadData = payloadData.res;
            else if (payloadData?.data?.lane) payloadData = payloadData.data.lane;
            else if (payloadData?.lane) payloadData = payloadData.lane;
            state.laneList = payloadData || [];
         })
         .addCase(fetchAdhocLaneListAsync.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
         })
         .addCase(fetchAdhocLaneAsync.pending, (state) => {
            state.loading = true;
            state.error = null;
         })
         .addCase(fetchAdhocLaneAsync.fulfilled, (state, action) => {
            state.loading = false;
            state.singleLane = action.payload?.data?.lane[0];
         })
         .addCase(fetchAdhocLaneAsync.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
         });
   },
});

export const { resetLane } = adhocLaneSlice.actions;

// Export the reducer
export default adhocLaneSlice.reducer;
